import React from 'react'
import { useContext, useState, useEffect, useNavigate } from 'react';
import DataContext from '../Context/DataContext';
import { useLocation } from 'react-router-dom';
// import BasicImageList from '../CowImageList/BasicImageList';
import ProgressIndicator from '../Indicator/ProgressIndicator';
import RawImageList from './RawImageList';
// import ProgramCOmmentsList from './programcommentslist';
import FabBottom from '../Fab/fabbotton';
import TextCaptureModal from '../Dialog/textcapturemodal';
// import { da } from 'date-fns/locale';
import MessageToast from '../Dialog/MessageToast';

const ProgramList = () => {
    const { items } = useContext(DataContext);
    const [imagelist, setImageList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setLoadingValue]=useState(false);
    const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });

    // console.log(isLoading);
//    let navigate = useNavigate();
    const location = useLocation();
    const pc = location.state.ParticipatingCows;
    const pid = location.state.ProgramId;
    const aut = "admin";

//    const srtdata = pc.slice(1, -1);
    const dataary = pc.split(",");
    // console.log(dataary);
    const idSet = new Set(dataary);
  //  console.log("pc " + idSet);

    const listdata = items.filter(item => idSet.has(String(item.cowid)));
//    console.log(pc);

    const showToast = (msg, sev = 'success') => {
        setToast({ open: true, message: msg, severity: sev });
      };

    const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return; // Don't close if user clicks elsewhere
    setToast({ ...toast, open: false });
  };
  //    console.log(listdata);
//console.log(items);

    useEffect(()=>{
      if (!isLoading){
        setImageList(
            listdata.map(item =>{         
              const infolist = [
                `Days since last delivery: ${item.dayssincelastdelivery}`,
                `Days since IV: ${item.dayssinceiv===999?'NA': item.dayssinceiv}`,
                `Days since Heat: ${item.dayssinceheat===999?'NA': item.dayssinceheat}`
              ];
                return (
                    [
                        item.cowid,
                        item.image1,
                        item.tag,
                         item.status,
                        item.isMilking,
                        item.isVerified,
                        item.status,
                        infolist
                    ]
                );        
            }).filter(value => (value[3] === 'Adult Female' & value[4] === 0))
        );
      }
    },[isLoading]);
//    console.log(items);

const handlefabclick=(data)=>{
    setIsModalOpen(true)

}

async function handleFinalSubmit  (text)  {
    // console.log("Captured Text:", text);
    setLoadingValue(true);
    try{
          const API_URL = `https://sasyavatagro.com/repos/api/dairyfarm/InsertProgramComments?Comment=${text}&Author=${aut}&ProgramId=${pid}`; 
          const response = await fetch(API_URL);
          if (!response.status) throw Error("Failed to fetch data");
          const result = await response.json();    
          showToast("Comment saved successfully!", "success");
    } catch(e){
      console.log(e)
    } finally {
      setLoadingValue(false);      
    }
    // You can now navigate and pass this captured text as state
    // navigate('/result', { state: { userText: text } });
  };

  return (
    <>
     {isLoading && <ProgressIndicator /> }
{    !isLoading && 
      <div>
        <MessageToast 
        open={toast.open} 
        handleClose={handleCloseToast} 
        message={toast.message} 
        severity={toast.severity}
        />
      <RawImageList title={location.state.Title} imglist={imagelist} data={location.state} />     
      <div style={{height:'40px'}}></div>
      <FabBottom handleClick={handlefabclick}/>
      <TextCaptureModal 
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        handleSubmit={handleFinalSubmit}
        title={"Enter Program Comment"}
      />
      </div>

      }      

    </>
  )
}

export default ProgramList